
import React from 'react';
import { Modal } from '../ui/Modal';
import { Button } from '../ui/Button';
import { CrownIcon } from '../ui/icons';

interface InstallPwaModalProps {
  isOpen: boolean;
  onClose: () => void;
  onInstall: () => void;
  isIOS: boolean;
  canTriggerAutomatic: boolean;
}

export const InstallPwaModal: React.FC<InstallPwaModalProps> = ({ isOpen, onClose, onInstall, isIOS, canTriggerAutomatic }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="App installieren">
      <div className="flex flex-col items-center text-center space-y-6">
        <div className="p-6 bg-gradient-to-br from-primary/20 to-surface border border-primary/30 rounded-full shadow-[0_0_30px_rgba(139,92,246,0.3)]">
            <CrownIcon className="w-16 h-16 text-primary" />
        </div>
        
        <div>
            <h3 className="text-xl font-bold mb-2 font-heading text-white">Fairyrealm App</h3>
            <p className="text-text-secondary text-sm">
                Installiere die App für das volle Erlebnis:<br/>
                Vollbild, Push-Benachrichtigungen und schnellerer Zugriff.
            </p>
        </div>

        {isIOS ? (
            <div className="bg-surface-light/50 p-5 rounded-xl text-left w-full border border-border relative overflow-hidden">
                <div className="absolute top-0 left-0 w-1 h-full bg-blue-500"></div>
                <p className="font-bold mb-3 text-white flex items-center gap-2">
                    <span className="text-xl">🍎</span> iOS Installation
                </p>
                <ol className="space-y-3 text-sm text-gray-300">
                    <li className="flex items-start gap-3">
                        <span className="bg-surface w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs border border-gray-600 flex-shrink-0">1</span>
                        <span>Tippe unten im Safari-Menü auf das <span className="text-blue-400 font-bold">Teilen-Symbol</span> (Viereck mit Pfeil).</span>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="bg-surface w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs border border-gray-600 flex-shrink-0">2</span>
                        <span>Scrolle nach unten und wähle <span className="text-white font-bold">&quot;Zum Home-Bildschirm&quot;</span>.</span>
                    </li>
                    <li className="flex items-start gap-3">
                        <span className="bg-surface w-6 h-6 rounded-full flex items-center justify-center font-bold text-xs border border-gray-600 flex-shrink-0">3</span>
                        <span>Bestätige oben rechts mit <span className="text-blue-400 font-bold">&quot;Hinzufügen&quot;</span>.</span>
                    </li>
                </ol>
            </div>
        ) : canTriggerAutomatic ? (
             <Button onClick={onInstall} className="w-full py-4 text-lg shadow-glow animate-pulse bg-gradient-to-r from-primary to-accent border-none font-bold tracking-wide">
                📲 Jetzt installieren
            </Button>
        ) : (
            <div className="bg-surface-light/50 p-5 rounded-xl text-left w-full border border-border">
                <p className="font-bold mb-2 text-white">Manuelle Installation:</p>
                <p className="text-sm text-gray-300">
                    Öffne das Browser-Menü (meistens drei Punkte oben rechts) und wähle <strong>&quot;App installieren&quot;</strong> oder <strong>&quot;Zum Startbildschirm hinzufügen&quot;</strong>.
                </p>
            </div>
        )}

        <Button variant="secondary" onClick={onClose} className="w-full text-text-secondary hover:text-white">
            Vielleicht später
        </Button>
      </div>
    </Modal>
  );
};
